import Site from "../Site";

export default class AddToCart {
    private $el;

    public constructor($el: JQuery) {
        this.$el = $el;

        this.initHtml();
    }

    public initHtml(): void {
        var $this = this.$el;

        var $quantity=$('.addtocart__quantity', $this);
        const $iquantity=$('input', $quantity);
        var $button=$('.addtocart__button', $this);

        let inpackage = parseInt($this.data('inpackage'));

        if (!inpackage) {
            inpackage = 1;
        }

        var adding=false;

        function reset() {
            $iquantity.val(inpackage);
        }

        function getVars() {
            var vars=$(':input', $this).serializeArray();

            if ($this.data('id')) {
                vars.push({
                    name: 'id',
                    value: $this.data('id')
                });
            }

            return vars;
        }

        function submit() {
            if (adding) {
                return;
            }

            const val = parseInt($iquantity.val());

            if (val % inpackage != 0) {
                return;
            }

            adding=true;

            $this.addClass('addtocart--added');

            // const vars = getVars();

            AddToCart.addToCart($this.data('id'), val, () => {
                reset();

                window.setTimeout(function() {
                    $this.removeClass('addtocart--added');
                }, 2000);

                adding = false;
            });
        }

        $button.click(function (e) {
            e.preventDefault();

            submit();
        });

        (<any> $iquantity).qSpinner({
            min: inpackage,
            value: $iquantity.val(),
            step: inpackage,

            onLazySpin: function(e, val) {
                // console.log('update');
            }
        });
    }

    public static addToCart(id: string, quantity: number, oncomplete?: () => void, update: boolean = true): void {
        let data = {
            id: id,
            quantity: quantity,
        };

        if (update) {
            Site.dispatchUpdateCartStart();
        }

        $.post('/cartapi/add', data, (r) => {
            if (update) {
                const html = `
                    <div>
                        <p>Produkt został dodany do koszyka.</p>

                        <br>

                        <button class="button button--1" onclick="$.fancybox.close();">Kontynuuj zakupy</button>
                        <a href="/cart/" class="button button--1">Zobacz koszyk</a>
                    </div>
                `;

                (<any> $).fancybox.open({
                    src: html,
                    type: 'html',
                    baseClass: 'fancybox--addtocart',
                });

                Site.dispatchUpdateCart();
            }

            oncomplete();
        });
    }
}
